









import Vue from 'vue';
import LoadingSpinner from './LoadingSpinner.vue';

export default Vue.extend({
  name: 'LoadingOverlay',
  props: {
    isLoading: {
      required: true,
      type: Boolean
    }
  },
  components: { LoadingSpinner }
});
